import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import useScrollDirection from '../hooks/useScrollDirection';

const Header = () => {
  const { user, isAuthenticated, logout } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const { scrollDirection, isAtTop } = useScrollDirection(10);

  const handleLogout = () => {
    logout();
    navigate('/');
    setMenuOpen(false);
  };

  // Bestem om header skal skjules på mobil
  const shouldHideOnMobile = scrollDirection === 'down' && !isAtTop && !menuOpen;

  return (
    <header 
      className={`
        bg-[#0A1929] text-white sticky top-0 z-50 shadow-lg
        transition-transform duration-300 ease-in-out
        ${shouldHideOnMobile ? '-translate-y-full md:translate-y-0' : 'translate-y-0'}
      `}
    >
      <div className="max-w-7xl mx-auto px-4">
        {/* Mobile Header - Forenklet for app-stil */}
        <div className="md:hidden flex items-center justify-center h-14 relative">
          <Link to="/" className="flex items-center gap-2">
            <div className="w-7 h-7 bg-white rounded-lg flex items-center justify-center">
              <span className="text-[#0A1929] font-bold text-base">M</span>
            </div>
            <span className="font-heading font-bold text-lg tracking-tight">Minitask</span>
          </Link>
          
          {/* Søk-knapp på høyre side */}
          <button 
            onClick={() => navigate('/?search=true')}
            className="absolute right-0 p-2"
            aria-label="Søk"
          >
            <span className="material-symbols-outlined text-xl">search</span>
          </button>
        </div>

        {/* Desktop Header - Uendret */}
        <div className="hidden md:flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
              <span className="text-[#0A1929] font-bold text-lg">M</span>
            </div>
            <span className="font-heading font-bold text-xl tracking-tight">Minitask</span>
          </Link>

          {/* Desktop Navigation */}
          <nav className="flex items-center gap-6">
            <Link to="/" className="hover:text-blue-300 transition-colors">
              Finn oppdrag
            </Link>
            {isAuthenticated && (
              <Link to="/opprett-annonse" className="hover:text-blue-300 transition-colors">
                Legg ut oppdrag
              </Link>
            )}
          </nav>

          {/* Desktop User Actions */}
          <div className="flex items-center gap-4">
            {isAuthenticated ? (
              <div className="flex items-center gap-4">
                <Link 
                  to={`/profil/${user.id}`}
                  className="flex items-center gap-2 hover:text-blue-300 transition-colors"
                >
                  <span className="material-symbols-outlined">account_circle</span>
                  <span>{user.name}</span>
                </Link>
                <button
                  onClick={handleLogout}
                  className="bg-white/10 hover:bg-white/20 px-4 py-2 rounded-lg transition-colors"
                >
                  Logg ut
                </button>
              </div>
            ) : (
              <div className="flex items-center gap-3">
                <Link 
                  to="/logg-inn"
                  className="hover:text-blue-300 transition-colors"
                >
                  Logg inn
                </Link>
                <Link 
                  to="/registrer"
                  className="bg-white text-[#0A1929] px-4 py-2 rounded-lg font-medium hover:bg-blue-100 transition-colors"
                >
                  Registrer deg
                </Link>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
